import axios from 'axios'
import Table from 'rc-table'
import { useEffect, useState } from 'react'
import { totalTrafficAdmin, userTraffic, userTrafficSingle } from '../../api/api'
import Loading from '../Loading'
import SubjectTypeFilterSelect from '../reports/SubjectTypeFilterSelect'
import {
  SUBJECT_TYPE_FILTER_ALL,
  parseSubjectTypeFilter,
} from '../../services/reportFilterHelper'

const columns = [
  { title: '', dataIndex: 'name', key: 'name', width: 100 },
  { title: 'امروز', dataIndex: 'today', key: 'today', width: 100 },
  { title: 'دیروز', dataIndex: 'yesterday', key: 'yesterday', width: 100 },
  { title: 'هفته', dataIndex: 'week', key: 'week', width: 100 },
  { title: 'ماه', dataIndex: 'months', key: 'months', width: 100 },
  { title: 'کل', dataIndex: 'total', key: 'total', width: 100 },
]

const buildTrafficTableData = (data, priceField = 'publisherPrice') => {
  if (!data?.traffics?.length) {
    return []
  }

  const operators = data.operators || []

  return data.traffics.reduce((rows, traffic, index) => {
    const operator = operators.find((item) => item.id === traffic.operatorType)

    if (!operator) {
      return rows
    }

    rows.push({
      name: (
        <>
          {operator.title}
          <span>
            هر گیگ {operator[priceField]} (تومان)
          </span>
        </>
      ),
      today: traffic.today ?? 0,
      yesterday: traffic.yesterday ?? 0,
      week: traffic.week ?? 0,
      months: traffic.month ?? 0,
      total: traffic.total ?? 0,
      key: index,
    })

    return rows
  }, [])
}

const getTrafficUrl = (source, subjectId, subjectType) => {
  switch (source) {
    case 'admin':
      return totalTrafficAdmin(subjectType)
    case 'producer':
      return userTraffic(subjectType)
    case 'single':
      return userTrafficSingle(subjectId, subjectType)
    case 'publisher':
    default:
      return userTraffic(subjectType)
  }
}

export default function TrafficStatsTable({
  title = 'آمار ترافیک',
  source = 'publisher',
  priceField = 'publisherPrice',
  subjectId = null,
  bordered = false,
  titleExtra = null,
}) {
  const [subjectTypeFilter, setSubjectTypeFilter] = useState(SUBJECT_TYPE_FILTER_ALL)
  const [isLoading, setIsLoading] = useState(false)
  const [tableData, setTableData] = useState([])

  const typeParam = parseSubjectTypeFilter(subjectTypeFilter)

  useEffect(() => {
    if (source === 'single' && !subjectId) {
      return
    }

    const loadTraffic = async () => {
      try {
        setIsLoading(true)
        const res = await axios.get(getTrafficUrl(source, subjectId, typeParam))
        setTableData(buildTrafficTableData(res.data, priceField))
      } catch {
        setTableData([])
      } finally {
        setIsLoading(false)
      }
    }

    loadTraffic()
  }, [source, subjectId, typeParam, priceField])

  const handleChangeSubjectType = (event) => {
    setSubjectTypeFilter(event.target.value)
  }

  return (
    <div className="box_radios">
      <div className={`headHolder ${bordered ? 'bordered' : ''}`}>
        <p className="title">
          {title}
          {titleExtra}
        </p>

        <SubjectTypeFilterSelect
          value={subjectTypeFilter}
          onChange={handleChangeSubjectType}
        />
      </div>

      {isLoading ? (
        <Loading styles="mini" />
      ) : (
        <Table columns={columns} data={tableData} tableLayout="auto" />
      )}
    </div>
  )
}
